import React from 'react';
import HeroSection from '../components/home/HeroSection';
import WhoWeAre from '../components/home/WhoWeAre';
import FeedCategories from '../components/home/FeedCategories';
import WhyChooseUs from '../components/home/WhyChooseUs';
import WhatWeOffer from '../components/home/WhatWeOffer';
import LocalService from '../components/home/LocalService';
import Testimonials from '../components/home/Testimonials';
import CTASection from '../components/home/CTASection';

const HomePage = () => {
  return (
    <main>
      <HeroSection />
      <WhoWeAre />
      <FeedCategories />
      <WhyChooseUs />
      <WhatWeOffer />
      <LocalService />
      <Testimonials />
      <CTASection />
    </main>
  );
};

export default HomePage;
